import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsSporkEnabled = (): boolean | undefined => {
  const { value } = useFeatureGate('trello_xf_spork_rebranding');
  return value;
};
